import _ from "lodash"
import config from "../constants/config"
import { SeeByT } from "../types/SeeByT"
import { AxiosInstance } from "../utils/RequestMethods"




export const getSeeByItems = async (jobId: number, params: {}): Promise<Array<SeeByT>> => {
    const defaultParams = {
        // all: true, 
        // order: "desc"
    }
    let data = { ...defaultParams, ...params }
    let url = `${config.url.jobs}/${jobId}/see-by`
    try {
        const res = await AxiosInstance.get(`${url}`, {
            data: data
        })
        return  _.isArray(res?.data) ? res?.data : []
    } catch (error) {
        throw error
    }
}
